import getAPIPath from '../modules/api-location';

window.searchDrillsService = function(searchTerm, searchQty, successFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/content/search?search_term=${searchTerm}&search_qty=${searchQty}`,
    type: 'GET',
    success: successFn,
    async: true,
    xhrFields: {
      withCredentials: true,
    },
  });
};



// WEBPACK FOOTER //
// ./library/js/services/drillSearch.service.js